'use client';

import React from 'react';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import UkassaTarget from '../reusable-components/layouts-components__ukassa/target';
import UkassaTasks from '../reusable-components/layouts-components__ukassa/tasks';
import UkassaProcess from '../reusable-components/layouts-components__ukassa/process';
import UkassaJob from '../reusable-components/layouts-components__ukassa/job';
import UkassaResult from '../reusable-components/layouts-components__ukassa/result';
import UkassaTeam from '../reusable-components/layouts-components__ukassa/team';
import UkassaOutput from '../reusable-components/layouts-components__ukassa/output';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import CommonSmallText from '../common-components/common-small-text';
import CommonSmallTitle from '../common-components/common-small-title';

const upgreatMainTitle = {
    titleMainText: `ЮКаssа: битва за трафик после ребрендинга`,
    titleAnimation: '/images/png/ukassa.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#16BE96',
            nameText: 'ЮКаssа',
        },
        {
            modeText: 'Услуги',
            colorMode: '#16BE96',
            nameText: 'SEO: аудит, разработка стратегии',
        },
    ],
};

const UkassaLanding = () => {
    const casePathname = '/cases/marketing/yookassa';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section className="ukassa-landing">
            <div className="ukassa__title-wrap">
                <MainTitle MainTitle={upgreatMainTitle}>
                    <CommonSmallTitle className="ukassa__subtitle">
                        <img
                            src="/images/svg/ukassa/ukassa-logo.svg"
                            alt=""
                            className="ukassa__subtitle-img"
                            loading="lazy"
                        />
                    </CommonSmallTitle>
                    <CommonSmallText>
                        SEO проекта наша команда занималась с мая 2019 года. Основные метрики,
                        которые мы обслуживаем: позиции и небрендовый трафик. В конце 2020 года
                        проект по решению клиента перенесли на другой домен. Нам предстояло решить
                        сложную и стратегически важную задачу — сохранить небрендовый трафик и при
                        этом минимизировать потери позиций в поисковой выдаче.{' '}
                    </CommonSmallText>
                </MainTitle>
            </div>

            <UkassaTarget />

            <UkassaTasks />

            <UkassaProcess />

            <UkassaJob />

            <UkassaResult />

            <UkassaOutput />

            <UkassaTeam />

            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default UkassaLanding;
